import Vue from 'vue'
import {
    MLInstaller,
    MLCreate,
    MLanguage
} from 'vue-multilanguage'

import en from './en'
import vi from './vi'

Vue.use(MLInstaller)

export default new MLCreate({
    save: true,
    initial: 'Vietnamese',
    languages: [
        new MLanguage('English').create(en),
        new MLanguage('Vietnamese').create(vi),
    ]
})